import { useCookies } from '@vueuse/integrations/useCookies';

const authToken = useCookies(['token']);

export const useToken = () => {
  return {
    getToken: () => authToken.get('token'),
    setToken: authToken.set,
    removeToken: authToken.remove,
  };
};
